import { defineComponent } from 'vue'
import './style.sass'

export default defineComponent({
  props: {
    delivery: {
      type: String,
      default: () => ''
    },
    address: {
      type: String,
      default: () => ''
    }
  },
  setup (props) {
    return () => {
      return (
        <div class="orders-item-address">
          <img src={require('@/assets/map-balun.svg')} />
          <div class="orders-item-address-content">
            <p>{`Доставка ${props.delivery}`}</p>
            <p>{props.address}</p>
          </div>
        </div>
      )
    }
  }
})